<template>
  <div class="video-wrap">
    <div class="flvvideo-title">
      {{ cameraName }}
      <span v-if="viewMode === 'static'" @click="closeVideo"></span>
    </div>
    <video
      class="video"
      :id="'flvVideo' + currentIndex"
      muted
      autoplay
      controls
      ref="player"
      width="100%"
      height="100%"
      @play="play"
      @pause="stop"
    ></video>
    <div class="video-statusbar" v-if="loadStatus === true">
      {{ loadMsg }}
    </div>
    <!-- <div v-else class="errow">
      此视频资源暂无法播放，请查看后再试
    </div> -->
  </div>
</template>

<script>
import flvjs from "flv.js";
import utils from "../../utils";
import HuaWeiApis from "../../../src/api";
import { getStreamUrl, toHttpFlv } from "../../api/src/videoApiGb";
import axios from 'axios';
export default {
  name: "flvPlayerRealTimeNew",
  props: {
    viewMode: {
      default: "static",
      type: String,
    },
    currentIndex: {
      type: Number,
    },

    item: {
      type: Object,
    },

    cameraId: {
      type: String,
    },
    cameraName: {
      type: String,
    },
  },
  data() {
    return {
      aspect: "100%",
      fluent: true,
      autoplay: true,
      showErrow: false,
      player: null,
      isShowClose: false,
      url: "",
      loadMsg: "",
      loadStatus: false,
      isClose: false,
      lastDecodedFrame: 0,
      monitorGBUrl:'',
      playUrl:'',
      streamUrl:""  //转流的域名，不想配置，改成获取的
    };
  },
  watch: {
    // cameraId(newVal,oldval) {
    //   this.destoryVideo(oldval)
    //   this.onCameraIdChanged();
    // },
    item(newval,oldVal) {
      this.destoryVideo(oldVal);
      this.loadVideo();
    },    
    currentIndex:{
      handler(val) {
        this.getStartUrl(val)
      },
      immediate: true,
      deep: true
    },
    url() {
      this.onUrlChanged();
    },
  },
  mounted() {
    this.monitorGBUrl = typeof(this.config.api.monitorGBUrl) == 'string' ? this.config.api.monitorGBUrl : this.config.api.monitorGBUrl[0],
    console.log(this.monitorGBUrl)
    // if (this.cameraId && !this.isClose) {
    //   this.getPreviewStreamInfo(this.cameraId, this.cameraName);
    // }
    this.loadVideo()
  },
  beforeUpdate() {
    this.isClose = false;
    this.destoryVideo();
    // this.$nextTick(() => {
    //   if (this.url && this.url != "") {
    //     this.createFlv(this.url);
    //   }
    // });
  },
  beforeDestroy() {
    this.destoryVideo();
    // this.$nextTick(() => {
    //   if (this.url && this.url != "") {
    //     this.createFlv(this.url);
    //   }
    // });
  },
  destroyed() {},
  methods: {
    getStartUrl(videoIndex){
      let url = this.streamUrl || this.config.api.monitorGBUrl;
      if(typeof(url) == 'string'){
        this.playUrl = url
      }else{
        this.playUrl = url[Math.floor((videoIndex + 1) / 3)] || url[0]
      }

    },
    loadVideo() {
      if (!this.isClose) {
        console.log("this.item")
        console.log(this.item)
       if(this.item.protocol == 'gb28181'){//如果是这两项不管有没有currentAddress都去获取播放流
          this.getPreviewStreamInfo();
        }else if(this.item.protocol == 'api' && !this.item.type){
          this.getStreamUrlById();
        }else if(this.item.currentAddress){
          let videoUrl = this.item.currentAddress
          if (videoUrl.indexOf("http") == 0) {
            this.url = videoUrl
            this.createFlv(videoUrl);
          } else if (videoUrl.indexOf("rtsp") == 0) {
            this.videoToHttpFlv(videoUrl);
          }
      }
      }
    },
       // 根据id获取流地址
    getStreamUrlById(){
      getStreamUrl({
        id: this.item.id,
        protocol:  this.config.api.apiProtocol || 'rtsp',//头屯河谷api视频 protocol为hls
      }).then((res) => {
        console.log(res)
        if (res.data) {
          let videoUrl = res.data;
          if (videoUrl.indexOf("http") == 0) {
            if(res.code == 201 ){//如果返回201，也要走转流服务
              this.videoToHttpFlv(videoUrl);
            }else{
              this.url = videoUrl
            }
          } else if (videoUrl.indexOf("rtsp") == 0) {
            this.videoToHttpFlv(videoUrl);
          }
        }
      });
    },
    videoToHttpFlv(url) {
      let camId = this.item.id;
      if(this.viewMode === 'round'){//如果轮巡需要拿监控id
        camId = this.item.monitorId.split('-')[1]
      }
      toHttpFlv({
          type: "rtsp",
          inUrl: url || this.item.currentAddress,
          camcode: this.config.area.code + "-" + camId,
        },this.playUrl).then((res) => {
          if (res.code == 0) {
            this.url = this.playUrl + '/video/relay/' + res.data.outUrl
          }
        });
    },
    getPreviewStreamInfo() {
      // axios.defaults.withCredentials = true;
      console.log(this.config)
      const that = this;
      that.loadMsg = "取流中...";
      that.loadStatus = true;
      axios({
        method: "get",
        url: this.monitorGBUrl + "/play/start/" + this.item.deviceId + '/' + this.item.channelId,
        // 设置请求头信息
        // headers: {
        //   Cookie:
        //     "JSESSIONID=E940237164112273E7DBD3E822ED1F73; session=%7B%22username%22%3A%22admin%22%7D; SECKEY_ABVK=EDPX8Nu/VORZNiVabA+AVESQgOFC/m4Ii9OI6VfJcHw%3D; BMAP_SECKEY=Nv0LHDaHFKlnYYhlqOmfzmFFaTQ6M29bl0duknXxWHL6HHi7F8Bg0OrHRy6IbRsQXEfZ3EMZDeB_ozTTec3ld_GCqS5_4Nh8-YoGDtwIUbDiyReMYnkYQ6If9DoaMB68lWmGmowivPFcH4ce8E-IyYzV59KhJbid_HIIda8GM7xMENa9N53E7XNwW3xoVW05",
        // },
      })
        .then(function (res) {
          console.log(res);
          if (res.data.code === 0) {
            that.loadStatus = false;
            const streamInfo = res.data.data;
          
            var scheme = window.location.protocol;
            var is_https = scheme == "https:";
            if (is_https && streamInfo.httpsServers) {
              that.streamUrl = streamInfo.httpsServers;
            } else if (!is_https && streamInfo.httpServers) {
              that.streamUrl = streamInfo.httpServers;
            }
            that.getStartUrl(that.currentIndex)
            //that.play(that.getUrlByStreamInfo(streamInfo));
             that.url = that.getUrlByStreamInfo(streamInfo);
          
          } else {
            that.loadStatus = true;
            that.$message.error(res.msg);
            that.loadMsg = res.msg;
          }
        })
        .catch(function (e) {
          console.error(e);
          that.loadStatus = true;
          that.loadMsg = e.msg ? e.msg : "取流失败";
        });
    },
    //  getUrlByStreamInfo(streamInfo) {
    //    var scheme = window.location.protocol,is_https = scheme == 'https:',data = ''
    //   if (is_https) {
    //     if (streamInfo.wss_flv === null) {
    //       console.error("媒体服务器未配置ssl端口, 使用http端口");
    //       data = streamInfo.ws_flv;
    //     } else {
    //        data = streamInfo.wss_flv;
    //     }
    //   } else {
    //     data = streamInfo.ws_flv;
    //   }
    //   console.log(is_https,data,'=========data=======================')
    //   if(typeof(data) == 'string'){
    //     return data
    //   }else{
    //     return data.url
    //   }
    // },
    getUrlByStreamInfo(streamInfo) {
      // return `${baseZlmApi}/${streamInfo.app}/${streamInfo.streamId}.flv`;
      // return `http://${baseZlmApi}/${streamInfo.app}/${streamInfo.streamId}.flv`;
      console.log(window.location.href, "0000");
      let scheme = window.location.protocol,
        data = "";
      if (scheme == "https:") {
        if (streamInfo.https_transcode) {
          data = streamInfo.https_transcode;
        } else if (streamInfo.https_flv) {
          data = streamInfo.https_flv;
        } else {
          console.error("媒体服务器未配置ssl端口, 使用http端口");
          data = streamInfo.ws_flv;
        }
        // if (streamInfo.https_flv === null) {
        //   console.error("媒体服务器未配置ssl端口, 使用http端口");
        //   // this.$message({
        //   //   showClose: true,
        //   //   message: '媒体服务器未配置ssl端口, ',
        //   //   type: 'error'
        //   // });
        //   data = streamInfo.ws_flv;
        // } else {
        //   data = streamInfo.https_flv;
        // }
      } else {
        if (streamInfo.http_transcode) {
          data = streamInfo.http_transcode;
        } else {
          data = streamInfo.ws_flv;
        }
        // return streamInfo.flv.url;
      }
      console.log("视频地址：", data)
      if (typeof data == "string") {
        return data;
      } else {
        return data.file;
      }
    },
    stopDevicePush(item) {
      axios({
        method: "get",
        url: this.monitorGBUrl + "/play/stop/" + item.deviceId + '/' + item.channelId,
      }).then(function (res) {
        console.log("关闭流推送", res);
      });
    },
    getPreviewStreamInfo1(cameraId) {
      let that = this;
      that.loadMsg = "取流中...";
      that.loadStatus = true;

      utils
        .waitAll([
          () => {
            return new HuaWeiApis.HuaweiOpenApi().GetPreviewStreamInfo({
              cameraCode: cameraId,
              streamType: 2,
            });
          },
        ])
        .then((r) => {
          r = r[0].data.Data;

          if (r && r.outUrl && r.outUrl != "") {
            that.loadStatus = false;
            that.url = r.outUrl;
          }
        })
        .catch((e) => {
          console.error(e);
          // this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          that.loadStatus = true;
          that.loadMsg = e.RspMsg ? e.RspMsg : "取流失败";
        });
    },
    onCameraIdChanged() {
      if (this.cameraId && !this.isClose) {
        this.getPreviewStreamInfo(this.cameraId);
      }
    },

    onUrlChanged() {
      this.$nextTick(() => {
        if (this.url && this.url != "") {
          this.createFlv(this.url);
        }
      });
    },
    destoryVideo(item) {
      if (this.player) {
        this.loadStatus = false;
        this.player.pause();
        this.player.unload();
        this.player.detachMediaElement();
        this.player.destroy();
        this.player = null;
        if(item&&item.protocol == "gb28181"){
          this.stopDevicePush(item);
        }else if (this.item.protocol == "gb28181") {
          this.stopDevicePush(this.item);
        }
      }
    },
    closeVideo() {
      this.$emit("destoryVideo", this.currentIndex);
      this.isClose = true;
      this.loadStatus = false;
      this.destoryVideo();
    },
    mouseOver() {
      this.isShowClose = true;
    },
    mouseLeave() {
      this.isShowClose = false;
    },
    createFlv(file) {
      console.log(file,'================================');
      // if(this.monitorGBUrl !== this.playUrl){
      //   url = url.replace(this.monitorGBUrl.split('://')[1],this.playUrl.split('://')[1]);
      // }
      // console.log(url,'=========22=======================')
      let resultUrl = "";
      if(file){
        if (file.indexOf("http") != 0) {
          // this.getStartUrl(this.videoIndex)
          if (
            this.playUrl.indexOf("http:") == 0 &&
            window.location.protocol == "https:"
          ) {
            resultUrl = this.playUrl.replace("http:", "https:") + "/" + file;
          } else {
            resultUrl = this.playUrl + "/" + file;
          }
        } else {
          resultUrl = file;
        }
      }
      // 创建一个flvjs实例
      if (flvjs.isSupported()) {
        this.player = flvjs.createPlayer(
          {
            type: "flv",
            //  isLive: false,
            hasAudio: false, //解决含有音频流报错
            url: resultUrl
          },
          {
            enableWorker: false, //不启用分离线程
            enableStashBuffer: false, //关闭IO隐藏缓冲区
            fixAudioTimestampGap: false,
            reuseRedirectedURL: true, //重用301/302重定向url，用于随后的请求，如查找、重新连接等。
            autoCleanupSourceBuffer: true, //自动清除缓存
            lazyLoad: false,
          }
        );

        // 将实例挂载到video元素上面
        this.player.attachMediaElement(this.$refs.player);

        try {
          // 开始运行加载 只要流地址正常 就可以在h5页面中播放出画面了
          this.player.load();

          // this.player.play();
          let playPromise = this.player.play();
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                this.player.play();
              })
              .catch(() => {});
          }

          this.$emit("play", {});
        } catch (error) {
          console.log(error);
        }

        this.player.on(
          flvjs.Events.ERROR,
          (errorType, errorDetail, errorInfo) => {
            console.log("errorType:", errorType);
            console.log("errorDetail:", errorDetail);
            console.log("errorInfo:", errorInfo);
            //视频出错后销毁重新创建
            if (this.player) {
              this.player.pause();
              this.player.unload();
              this.player.detachMediaElement();
              this.player.destroy();
              this.player = null;
              if(file){
                this.createFlv(resultUrl);
              }
              
            }
          }
        );

        // this.player.on(flvjs.Events.STATISTICS_INFO, function (res) {
        //   if (this.lastDecodedFrame == 0) {
        //     this.lastDecodedFrame = res.decodedFrames;
        //     return;
        //   }
        //   if (this.lastDecodedFrame != res.decodedFrames) {
        //     this.lastDecodedFrame = res.decodedFrames;
        //   } else {
        //     this.lastDecodedFrame = 0;
        //     if (this.player) {
        //       this.player.pause();
        //       this.player.unload();
        //       this.player.detachMediaElement();
        //       this.player.destroy();
        //       this.player = null;
        //       this.createFlv(this.url);
        //     }
        //   }
        // });
      }
    },
    stop() {
      //在播放，断流
      this.player.pause();
      // this.player.unload();
      // this.player.detachMediaElement();

      this.$emit("stop", {});
    },
    play() {
      // 已断流，重新拉流播放
      // this.player.attachMediaElement(videoEl.current);
      // this.player.load();
      // this.player.play();
      this.player.play();
      this.$emit("play", {});
      //
    },
    fullScreen() {
      let element = this.$refs.player;
      this.Screen(element);
    },
    // 全屏
    Screen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else {
        var docHtml = document.documentElement;
        var docBody = document.body;
        var videobox = document.getElementById("flvVideo" + this.currentIndex);
        var cssText = "width:100%;height:100%;overflow:hidden;";
        docHtml.style.cssText = cssText;
        docBody.style.cssText = cssText;
        videobox.style.cssText = cssText + ";" + "margin:0px;padding:0px;";
        document.IsFullScreen = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.player-wrapper {
  width: 100%;
  height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 100%;
  padding-bottom: 0 !important;
}
.video-wrap {
  position: relative;
  .video {
    width: 100%;
    height: 100%;
  }
}
.video-wrap,
.video-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
}
.flvvideo-title {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  text-align: left;
  width: 100%;
  height: 50/1080 * 100vh;
  padding: 0 20/100 * 1rem;
  font-size: 16/100 * 1rem;
  line-height: 50/1080 * 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  padding-left: 1rem;
  span {
    position: absolute;
    right: 10px;
    top: 0;
    width: 30/1080 * 100vh;
    height: 50/1080 * 100vh;
    background: url("../../../public/theme/default/img/video/close.png")
      no-repeat center center;
    background-size: 20/1080 * 100vh 20/1080 * 100vh;
    cursor: pointer;
  }
}
.video-statusbar {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  text-align: left;
  width: 100%;
  height: 50/1080 * 100vh;
  padding: 0 20/100 * 1rem;
  font-size: 16/100 * 1rem;
  line-height: 50/1080 * 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  padding-left: 1rem;
}
.errow {
  width: 100%;
  height: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  background: #000;
  color: #fff;
  font-size: 14px;
  text-align: center;
}
.vjs-custom-skin > .video-js {
  height: 100%;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  height: 1.4em !important;
  line-height: 1.4em !important;
}
</style>